export default {"src":"/minerva/_next/static/media/lens.e01b2223.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};